import React from 'react';
import { Store, Factory, Briefcase, Calculator, Code, Building2 } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  Store, Factory, Briefcase, Calculator, Code, Building2
};

const TargetAudience = () => {
  const { targetAudience } = mockData;

  return (
    <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {targetAudience.title}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {targetAudience.subtitle}
          </p>
          <div className="w-20 h-1 bg-gradient-to-r from-purple-600 to-blue-600 rounded-full mx-auto mt-6" />
        </div>

        {/* Audiences Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {targetAudience.audiences.map((audience, index) => {
            const Icon = iconMap[audience.icon];
            return (
              <div
                key={index}
                className="group bg-gradient-to-br from-gray-50 to-white p-6 rounded-xl border border-gray-200 hover:border-purple-300 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-purple-100 to-blue-100 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-6 h-6 text-purple-600" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {audience.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {audience.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center bg-gradient-to-br from-purple-50 via-blue-50 to-cyan-50 rounded-2xl p-12">
          <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
            Pronto para Transformar sua Gestão Fiscal?
          </h3>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Junte-se a centenas de empresas que já confiam na EEDOC para gerenciar seus documentos fiscais e financeiros.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => document.getElementById('planos')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Ver Planos
            </button>
            <button
              onClick={() => window.open('https://gatewaysistemas.com.br/gway/#/gwaysistemas/sign-in', '_blank')}
              className="px-8 py-4 bg-white text-purple-600 font-semibold rounded-lg border-2 border-purple-600 hover:bg-purple-50 transition-all duration-300"
            >
              Acessar Sistema
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
